import { Link } from "react-router-dom";
import type { AnchorHTMLAttributes, ReactNode } from "react";

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  children: ReactNode;
};

/** Renders a client-side <Link> for internal paths, a plain same-window <a> otherwise.
 *  /go/ (tracked 302s) and /files/ (PDFs) are WORKER-handled paths, not SPA routes —
 *  they must be real <a> navigations or the redirect never happens. */
const SmartLink = ({ href, children, ...rest }: Props) => {
  const isInternal =
    href.startsWith("/") &&
    !href.startsWith("//") &&
    !href.startsWith("/go/") &&
    !href.startsWith("/files/");
  if (isInternal) {
    return (
      <Link to={href} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} target="_self" {...rest}>
      {children}
    </a>
  );
};

export default SmartLink;
